import React from 'react';

const LogoMark = () => (
  <svg className="footer-logo-mark" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect x="15" y="35" width="70" height="45" rx="6" fill="none" stroke="#1E40AF" strokeWidth="4"/>
    <line x1="15" y1="50" x2="85" y2="50" stroke="#14B8A6" strokeWidth="4"/>
    <rect x="25" y="60" width="18" height="12" rx="2" fill="#F59E0B"/>
    <line x1="55" y1="65" x2="75" y2="65" stroke="#1E40AF" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const Footer = ({ navigateTo, scrollToSection }) => (
  <footer className="footer" id="site-footer">
    <div className="footer-inner">
      <div className="footer-grid">
        <div>
          <div className="footer-logo">
            <LogoMark />
            <span className="footer-logo-name">SequPay</span>
          </div>
          <p className="footer-desc">A next-generation digital payment and financial services platform by SequSpace Technologies Pvt. Ltd. Early Access now live on Android.</p>
          <div className="footer-social">
            <a href="#!" aria-label="Twitter / X">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="#!" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.065-2.065 2.064 2.064 0 112.065 2.065zm1.782 13.019H3.554V9h3.565v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/></svg>
            </a>
            <a href="#!" aria-label="GitHub">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Product</h4>
          <ul>
            <li><button onClick={() => navigateTo('home')}>Home</button></li>
            <li><a href="https://play.google.com/store/apps/details?id=com.sequspace.sequpay" target="_blank" rel="noopener noreferrer">Download App</a></li>
            <li><button onClick={() => scrollToSection('features')}>Features</button></li>
            <li><button onClick={() => scrollToSection('roadmap')}>Roadmap</button></li>
            <li><button onClick={() => scrollToSection('security')}>Security</button></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><a href="#!">About Us</a></li>
            <li><a href="#!">Careers</a></li>
            <li><a href="#!">Blog</a></li>
            <li><a href="#!">Press Kit</a></li>
            <li><a href="mailto:support@sequspace.com">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Legal</h4>
          <ul>
            <li><button onClick={() => navigateTo('terms')}>Terms of Service</button></li>
            <li><button onClick={() => navigateTo('privacy')}>Privacy Policy</button></li>
            <li><a href="#!">Cookie Policy</a></li>
            <li><a href="#!">GDPR Compliance</a></li>
            <li><button onClick={() => navigateTo('delete')} style={{color:'rgba(239,68,68,.7)'}}>Delete Account</button></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Support</h4>
          <ul>
            <li><a href="mailto:support@sequspace.com">support@sequspace.com</a></li>
            <li><a href="mailto:privacy@sequspace.com">privacy@sequspace.com</a></li>
            <li><a href="https://sequspace.com" target="_blank" rel="noopener noreferrer">sequspace.com</a></li>
            <li><a href="#!">Help Centre</a></li>
            <li><a href="#!">Security Policy</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copy">© 2025 SequSpace Technologies Pvt. Ltd. All Rights Reserved.</div>
        <div className="footer-bot-links">
          <button onClick={() => navigateTo('terms')}>Terms</button>
          <button onClick={() => navigateTo('privacy')}>Privacy</button>
          <a href="mailto:support@sequspace.com">Contact</a>
          <a href="#!">Sitemap</a>
        </div>
      </div>

      <div className="footer-legal">
        SequPay is operated by SequSpace Technologies Pvt. Ltd. Financial products and services displayed in the app will be offered in partnership with regulated banks, Non-Banking Financial Companies (NBFCs), and licensed financial service providers. All live financial features will be activated only after obtaining the required regulatory approvals and licensing from the relevant authorities — including RBI, NPCI, SEBI, and IRDAI as applicable to each feature. <strong style={{color:'rgba(255,255,255,.4)'}}>No real financial transactions are currently processed through the app.</strong> All payment, loan, investment, and insurance screens visible at this stage are UI demonstrations.
      </div>
    </div>
  </footer>
);

export default Footer;
